(function () {
  const KEY = 'Fecha de despacho solicitada';
  const AUTO_KEY = '_mh_dispatch_automatic';
  const FIRST_DISPATCH_DATES = {respaldos:'2026-11-03',fundas:'2026-10-30',textiles:'2026-10-30'};
  const iso = d => d.toISOString().slice(0, 10);
  const parse = s => new Date(s + 'T12:00:00Z');
  function today(now = new Date()) {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:'America/Santiago',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).map(x => [x.type,x.value]));
    return p.year + '-' + p.month + '-' + p.day;
  }
  function dates(start, days, holidays, until, limit = 45, needed = []) {
    const d = parse(start), list = [];
    const first = needed.reduce((date, group) => FIRST_DISPATCH_DATES[group] > date ? FIRST_DISPATCH_DATES[group] : date, '2026-10-30');
    for (let n = 0; n < 180 && list.length < limit; n++) {
      d.setUTCDate(d.getUTCDate() + 1);
      const key = iso(d);
      if (key > until) break;
      if ([0,6].includes(d.getUTCDay()) || holidays.includes(key)) continue;
      if (key >= first) list.push(key);
    }
    return list;
  }
  function lead(items, headboards, other) {
    return items.reduce((days, item) => {
      if (item.gift_card || isReservation(item) || item.requires_shipping === false) return days;
      const type = (item.product_type || '').toLowerCase();
      return Math.max(days, type.includes('respaldo') && !type.includes('funda') ? headboards : other);
    }, other);
  }
  function mergeNote(note, value = '', automatic = false) {
    const clean = (note || '').split('\n').filter(line => !/^\[Despacho (?:solicitado|asignado automáticamente)\] \d{2}\/\d{2}\/\d{4}\s*$/.test(line)).join('\n');
    return clean + (value ? (clean && !clean.endsWith('\n') ? '\n' : '') + (automatic ? '[Despacho asignado automáticamente] ' : '[Despacho solicitado] ') + value.split('-').reverse().join('/') : '');
  }
  function hasHeadboard(items) { return items.some(item => /respaldo/i.test(item.product_type || '') && !/funda/i.test(item.product_type || '')); }
  function available(count, maximum = 3) { return Number.isInteger(count) && count >= 0 && count < maximum; }

  function isReservation(item) {
    return item.product_type === 'MH Reserva de despacho' || /^MH-RES-/.test(item.sku || '');
  }
  function groupOf(item) {
    if (isReservation(item) || item.gift_card || item.requires_shipping === false) return '';
    const type = (item.product_type || '').toLowerCase();
    if (type.includes('respaldo') && !type.includes('funda')) return 'respaldos';
    const description = type + ' ' + (item.product_title || item.title || '').toLowerCase();
    if (description.includes('funda') && description.includes('respaldo')) return 'fundas';
    return /funda|textil|coj[ií]n|piecera|manta|accesorios de cama|ropa de cama|s[aá]bana|plum[oó]n|cubre/.test(type + ' ' + (item.product_title || item.title || '').toLowerCase()) ? 'textiles' : '';
  }
  function groups(items) { return [...new Set(items.map(groupOf).filter(Boolean))]; }
  function automaticDate(source, inventory, start, holidays, until) {
    const needed = groups(source.items);
    if (!needed.length) return '';
    const minimum = needed.includes('respaldos') ? 10 : 3;
    const result = dates(start, minimum, holidays, until, 180, needed).find(date =>
      needed.every(group => Number.isInteger(inventory?.[group]?.[date]?.remaining) && inventory[group][date].remaining > 0)
    );
    if (!result) throw new Error('No quedan cupos disponibles en el calendario. Contáctanos para coordinar el despacho antes de pagar.');
    return result;
  }
  function reservationPlan(source, value, inventory) {
    const wanted = value ? groups(source.items).map(group => {
      const slot = inventory?.[group]?.[value];
      if (!slot || slot.remaining < 1) throw new Error('No quedan cupos para esa fecha. Elige otra fecha o usa el plazo habitual.');
      return {id:slot.id,quantity:1,properties:{_mh_dispatch_group:group,_mh_dispatch_date:value}};
    }) : [];
    const updates = {}, kept = new Set();
    source.items.filter(isReservation).forEach(item => {
      const match = wanted.find(w => Number(w.id) === Number(item.variant_id) && item.properties?._mh_dispatch_date === value);
      if (!match || kept.has(Number(item.variant_id))) updates[item.key] = 0;
      else { kept.add(Number(item.variant_id)); if (item.quantity !== 1) updates[item.key] = 1; }
    });
    return {updates,add:wanted.filter(w => !kept.has(Number(w.id)))};
  }

  function lineProperties(item, value) {
    const properties = {...(item.properties || {})};
    const desired = value && item.requires_shipping !== false && !item.gift_card ? value.split('-').reverse().join('/') : '';
    if ((properties[KEY] || '') === desired) return null;
    properties[KEY] = desired;
    return properties;
  }
  async function syncCheckoutProperties(source, value, send) {
    let latest = source;
    for (let n = 0; n < 200; n++) {
      const item = latest.items.find(item => lineProperties(item, value));
      if (!item) return latest;
      const properties = lineProperties(item, value);
      latest = await send('cart/change.js', {id:item.key,quantity:item.quantity,properties});
    }
    throw new Error('Dispatch details could not be synchronized');
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = {today,dates,lead,mergeNote,hasHeadboard,available,lineProperties,syncCheckoutProperties,isReservation,groupOf,groups,reservationPlan,automaticDate}; return; }
  if (window.MHDispatchDate) return;
  const widgets = () => Array.from(document.querySelectorAll('mh-dispatch-date'));
  let cart, chosen = '', pending = 0, failed = false, queue = Promise.resolve(), noteDraft, noteTimer, bypass = false;
  const root = window.Shopify.routes.root;
  let inventory = null, inventoryRequest, refreshRequest, lastError = '';
  const nativeFetch = window.fetch.bind(window);
  const config = () => widgets()[0]?.dataset;
  const message = (name) => config()?.[name] || '';
  const format = value => new Intl.DateTimeFormat(document.documentElement.lang || 'es', {weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}).format(parse(value));
  async function request(path, body) {
    const res = await nativeFetch(root + path, {method:body ? 'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body ? {body:JSON.stringify(body)} : {}),signal:AbortSignal.timeout(12000)});
    if (!res.ok) { const error = new Error('No pudimos actualizar el carrito. Vuelve a intentarlo.'); error.status = res.status; throw error; }
    return res.json();
  }
  function options(widget, source = cart) {
    const c = widget.dataset;
    const days = Math.max(Number(c.minimum), lead(source?.items || [], Number(c.headboards), Number(c.other)));
    const needed = groups(source?.items || []);
    if (c.productGroup && !needed.includes(c.productGroup)) needed.push(c.productGroup);
    return dates(today(), days, c.holidays.split(','), c.until, 45, needed);
  }
  async function loadInventory() {
    if (inventoryRequest) return inventoryRequest;
    inventoryRequest = (async () => {
      const response = await nativeFetch(root + '?section_id=mh-dispatch-capacity&_=' + Date.now(), {cache:'no-store',signal:AbortSignal.timeout(12000)});
      if (!response.ok) throw new Error('No pudimos consultar los cupos. Vuelve a intentarlo.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(html.querySelector('[data-mh-dispatch-capacity]')?.textContent || 'null');
      if (['respaldos','fundas','textiles'].some(group => !data?.[group] || !Object.keys(data[group]).length)) throw new Error('No pudimos consultar los cupos. Vuelve a intentarlo.');
      inventory = data;
    })().finally(() => { inventoryRequest = null; });
    return inventoryRequest;
  }
  function widgetGroups(w) {
    const list = groups(cart?.items || []);
    if (w.dataset.productGroup && !list.includes(w.dataset.productGroup)) list.push(w.dataset.productGroup);
    return list;
  }
  function remaining(date, list) {
    if (!inventory) return 0;
    return list.length ? Math.min(...list.map(group => inventory[group]?.[date]?.remaining || 0)) : 3;
  }
  async function syncReservations(source, value) {
    const plan = reservationPlan(source, value, inventory);
    let latest = source, changed = false;
    if (Object.keys(plan.updates).length) { latest = await request('cart/update.js', {updates:plan.updates}); changed = true; }
    if (plan.add.length) { await request('cart/add.js', {items:plan.add}); latest = await request('cart.js'); changed = true; }
    const check = reservationPlan(latest, value, inventory);
    if (check.add.length || Object.keys(check.updates).length) throw new Error('No pudimos guardar la reserva. Vuelve a intentarlo.');
    return {cart:latest,changed};
  }
  async function renderCart() {
    const targets = document.querySelectorAll('cart-items,cart-drawer-items');
    await Promise.all(Array.from(targets, target => target.onCartUpdate?.()));
    const footer = document.getElementById('main-cart-footer');
    if (footer?.dataset.id) {
      const response = await nativeFetch(root + '?section_id=' + encodeURIComponent(footer.dataset.id));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.getElementById('main-cart-footer');
      if (content) footer.innerHTML = content.innerHTML;
    }
    document.querySelector('cart-items')?.classList.toggle('is-empty', !cart?.item_count);
    footer?.classList.toggle('is-empty', !cart?.item_count);
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', !cart?.item_count);
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      const response = await nativeFetch(root + '?section_id=cart-icon-bubble');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('.shopify-section');
      if (content) bubble.innerHTML = content.innerHTML;
    }
  }
  function renderCalendar(w, allowed, slotGroups) {
    const grid = w.querySelector('[data-days]');
    const focused = grid.contains(document.activeElement) ? document.activeElement.dataset.date : null;
    const currentDay = today();
    const firstMonth = currentDay.slice(0,7);
    const firstAvailable = allowed.find(value => remaining(value, slotGroups) > 0);
    const lastMonth = (allowed.at(-1) || today()).slice(0,7);
    if (!w.initialMonthReady && cart && inventory) {
      w.month = chosen && allowed.includes(chosen) ? chosen.slice(0,7) : (firstAvailable || currentDay).slice(0,7);
      w.initialMonthReady = true;
    }
    if (!w.month || w.month < firstMonth || w.month > lastMonth) w.month = firstMonth;
    const first = parse(w.month + '-01');
    const monthLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'es', {month:'long',year:'numeric',timeZone:'UTC'}).format(first);
    w.querySelector('[data-month]').textContent = monthLabel.charAt(0).toLocaleUpperCase() + monthLabel.slice(1);
    w.querySelector('[data-prev]').disabled = w.month <= firstMonth || pending > 0;
    w.querySelector('[data-next]').disabled = w.month >= lastMonth || pending > 0;
    grid.replaceChildren();
    const offset = (first.getUTCDay() + 6) % 7;
    const day = new Date(first);
    day.setUTCDate(day.getUTCDate() - offset);
    for (let cell = 0; cell < 42; cell++) {
      const value = iso(day), permitted = allowed.includes(value);
      const beforeFirstAvailable = false;
      const full = beforeFirstAvailable || (permitted && remaining(value, slotGroups) < 1);
      const button = document.createElement('button'); button.type = 'button'; button.dataset.date = value;
      button.className = 'mh-calendar__day' + (value.slice(0,7) !== w.month ? ' is-adjacent-month' : '') + (full ? ' is-full' : '') + (chosen === value ? ' is-selected' : '');
      button.disabled = !permitted || full || pending > 0 || !cart || !inventory;
      button.setAttribute('aria-pressed', String(chosen === value));
      button.setAttribute('aria-label', format(value) + (full ? '. ' + w.dataset.full : permitted ? '. ' + w.dataset.availableLabel : '. ' + w.dataset.blockedLabel));
      const number = document.createElement('span'); number.textContent = day.getUTCDate(); button.append(number);
      if (value.slice(0,7) !== w.month) { const month = document.createElement('small'); month.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'es', {month:'short',timeZone:'UTC'}).format(day); button.append(month); }
      if (full) { const caption = document.createElement('small'); caption.textContent = w.dataset.fullShort; button.append(caption); }
      else if (permitted && slotGroups.length && remaining(value, slotGroups) === 1) { const caption = document.createElement('small'); caption.textContent = w.dataset.lastSlot; button.append(caption); }
      grid.append(button); day.setUTCDate(day.getUTCDate()+1);
    }
    const clear = w.querySelector('[data-clear]'); clear.hidden = !chosen; clear.disabled = pending > 0;
    if (focused) grid.querySelector('[data-date="' + focused + '"]:not(:disabled)')?.focus({preventScroll:true});
  }
  function paint(status) {
    document.querySelectorAll('[data-mh-dispatch-confirmation]').forEach(el => {
      const saved = cart?.attributes?.[KEY] || '';
      el.hidden = !saved;
      const label = el.querySelector('[data-mh-dispatch-value]');
      if (label) label.textContent = saved ? format(saved) : '';
    });
    widgets().forEach(w => {
      const select = w.querySelector('select');
      const allowed = options(w);
      const slotGroups = widgetGroups(w);
      const signature = allowed.join(',') + slotGroups.join(',') + JSON.stringify(inventory);
      if (select.dataset.signature !== signature) {
        select.replaceChildren(new Option(w.dataset.optional, ''));
        allowed.forEach(value => {
          const free = remaining(value, slotGroups);
          const option = new Option(format(value) + (slotGroups.length ? ' · ' + (free > 0 ? w.dataset.slots + ': ' + free : w.dataset.full) : ''), value);
          option.disabled = remaining(value, slotGroups) < 1;
          select.add(option);
        });
        select.dataset.signature = signature;
      }
      if (chosen && !allowed.includes(chosen)) select.add(new Option(w.dataset.invalid, chosen, false, true));
      select.value = chosen;
      select.disabled = pending > 0 || !cart || !inventory || !allowed.length;
      const compactLabel = w.querySelector('[data-compact-date-label]');
      if (compactLabel) compactLabel.textContent = chosen ? w.dataset.saved + ' ' + format(chosen) : 'Agendar fecha de Despacho';
      w.querySelector('[data-status]').textContent = status || lastError || (chosen && !allowed.includes(chosen) ? w.dataset.invalid : chosen && !compactLabel ? w.dataset.saved + ' ' + format(chosen) : '');
      w.querySelector('[data-retry]').hidden = !failed;
      const firstAvailable = allowed.find(value => remaining(value, slotGroups) > 0);
      const availabilityMessage = w.querySelector('[data-earliest]');
      availabilityMessage.textContent = firstAvailable ? '' : w.dataset.unavailable;
      availabilityMessage.hidden = Boolean(firstAvailable);
      renderCalendar(w, allowed, slotGroups);
      const timeline = w.closest('mh-order-timeline');
      if (timeline) {
        const saved = cart?.attributes?.[KEY] || '';
        timeline.dataset.requestedDate = allowed.includes(saved) && (remaining(saved, slotGroups) > 0) ? saved : '';
        timeline.dataset.nextDispatchDate = firstAvailable || '';
        timeline.dataset.availabilityLoaded = 'true';
        timeline.updateDates?.();
      }
    });
  }
  function enqueue(action) {
    pending++; paint(message('saving'));
    const task = queue.catch(() => {}).then(action);
    queue = task.then(() => { failed = false; lastError = ''; }, error => { failed = true; lastError = error.message; });
    return task.finally(() => { pending--; paint(failed ? lastError || message('error') : undefined); });
  }
  async function save(value, requiredDays, forCheckout = false) {
    return enqueue(async () => {
      let current = await request('cart.js');
      const automatic = forCheckout && (!value || current.attributes?.[AUTO_KEY] === 'true');
      if (value || automatic) await loadInventory();
      const c = config();
      if (automatic) value = automaticDate(current, inventory, today(), c.holidays.split(','), c.until);
      const days = Math.max(requiredDays || 0, lead(current.items, Number(c.headboards), Number(c.other)));
      const relevant = groups(current.items);
      if (!forCheckout) widgets().filter(w => Number(w.dataset.minimum) === requiredDays).forEach(w => {if (w.dataset.productGroup && !relevant.includes(w.dataset.productGroup)) relevant.push(w.dataset.productGroup);});
      if (!automatic && value && !dates(today(), days, c.holidays.split(','), c.until, 45, relevant).includes(value)) {
        cart = current; chosen = value; throw new Error('Esa fecha ya no está disponible. Elige otra fecha o usa el plazo habitual.');
      }
      if (value && remaining(value, relevant) < 1) throw new Error('No quedan cupos para esa fecha. Elige otra fecha o usa el plazo habitual.');
      for (let attempt = 0; ; attempt++) {
        try {
          const synchronized = await syncReservations(current, value);
          current = synchronized.cart;
          break;
        } catch (error) {
          if (!automatic || error.status !== 422 || attempt >= 2) throw error;
          current = await request('cart.js');
          await loadInventory();
          value = automaticDate(current, inventory, today(), c.holidays.split(','), c.until);
        }
      }
      const note = mergeNote(noteDraft === undefined ? current.note : noteDraft, value, automatic);
      cart = await request('cart/update.js', {attributes:{[KEY]:value,[AUTO_KEY]:automatic && value ? 'true' : ''},note});
      if ((cart.attributes?.[KEY] || '') !== value || (cart.note || '') !== note) throw new Error('No pudimos confirmar la fecha. Vuelve a intentarlo.');
      cart = await syncCheckoutProperties(cart, value, request);
      chosen = value;
      if (!forCheckout) await renderCart();
      widgets().forEach(w => { const details = w.querySelector('.mh-calendar__expand'); if (details) details.open = false; });
      document.querySelectorAll('textarea[name="note"]').forEach(el => {if (el !== document.activeElement) el.value = note;});
    });
  }
  async function refresh() {
    if (pending) { await queue; paint(); return; }
    if (refreshRequest) return refreshRequest;
    refreshRequest = (async () => {
      try {
        cart = await request('cart.js'); chosen = cart.attributes?.[KEY] || '';
        await loadInventory();
        const w = widgets().find(w => w.dataset.context !== 'product') || widgets()[0];
        const onlyReservations = cart.items.length > 0 && cart.items.every(isReservation);
        const invalid = cart.attributes?.[AUTO_KEY] === 'true' || chosen && (onlyReservations || !options(w, cart).includes(chosen) || remaining(chosen, groups(cart.items)) < 1);
        if (invalid) {
          const wasAutomatic = cart.attributes?.[AUTO_KEY] === 'true';
          const cleared = await syncReservations(cart, ''); cart = cleared.cart;
          cart = await request('cart/update.js', {attributes:{[KEY]:'',[AUTO_KEY]:''},note:mergeNote(cart.note)});
          cart = await syncCheckoutProperties(cart, '', request); chosen = '';
          lastError = wasAutomatic ? '' : 'La fecha anterior ya no está disponible para este carrito. Elige otra fecha o continúa con el plazo habitual.';
          if (cleared.changed) await renderCart();
        } else {
          const synced = await syncReservations(cart, chosen); cart = synced.cart;
          if (synced.changed) {cart = await syncCheckoutProperties(cart, chosen, request); await renderCart();}
          lastError = '';
        }
        failed = false; paint();
      } catch (error) { failed = true; lastError = error.message; paint(lastError || message('error')); }
    })().finally(() => {refreshRequest = null;});
    return refreshRequest;
  }
  window.MHDispatchDate = {refresh};
  customElements.define('mh-dispatch-date', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return; this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button'); if (!button || button.disabled) return;
        if (button.hasAttribute('data-prev') || button.hasAttribute('data-next')) {
          const month = parse(this.month + '-01'); month.setUTCMonth(month.getUTCMonth() + (button.hasAttribute('data-next') ? 1 : -1));
          this.month = iso(month).slice(0,7); paint();
        } else if (button.dataset.date || button.hasAttribute('data-clear')) {
          const select = this.querySelector('select'); select.value = button.dataset.date || ''; select.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
      this.querySelector('[data-days]').addEventListener('keydown', event => {
        const delta = {ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7}[event.key];
        if (!delta || !event.target.dataset.date) return;
        event.preventDefault(); const buttons = Array.from(this.querySelectorAll('[data-date]')); let index = buttons.indexOf(event.target) + delta;
        while (index >= 0 && index < buttons.length) {if (!buttons[index].disabled) {buttons[index].focus(); break;} index += Math.sign(delta);}
      });
      this.querySelector('select').addEventListener('change', event => {
        chosen = event.target.value;
        save(chosen, Number(this.dataset.minimum)).catch(() => {});
      });
      this.querySelector('[data-retry]').addEventListener('click', () => {
        if (!cart) refresh(); else save(chosen, Number(this.dataset.minimum)).catch(() => {});
      });
      refresh();
    }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('textarea[name="note"]') || !widgets().length) return;
    event.stopImmediatePropagation(); noteDraft = event.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => save(chosen).catch(() => {}), 300);
  }, true);
  document.addEventListener('submit', async event => {
    const button = event.submitter;
    if (!widgets().length || button?.name !== 'checkout' || bypass) return;
    event.preventDefault(); event.stopImmediatePropagation(); clearTimeout(noteTimer);
    const form = event.target;
    try {
      if (refreshRequest) await refreshRequest;
      await queue;
      if (!cart) await refresh();
      if (!cart) throw new Error('No pudimos actualizar el carrito. Vuelve a intentarlo.');
      await save(chosen, 0, true);
      document.querySelectorAll('textarea[name="note"]').forEach(el => {el.value = cart.note || '';});
      bypass = true; form.requestSubmit(button); bypass = false;
    } catch (_) { widgets().find(w => w.getBoundingClientRect().height)?.querySelector('[data-retry]').focus(); }
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 50));
  let calendarDay = today();
  function refreshDay() {
    if (document.hidden || !widgets().length || today() === calendarDay) return;
    calendarDay = today();
    paint();
    refresh();
  }
  setInterval(refreshDay, 30000);
  window.addEventListener('pageshow', () => {if (widgets().length) {calendarDay = today(); refresh();}});
  document.addEventListener('visibilitychange', () => {if (!document.hidden && widgets().length) {calendarDay = today(); refresh();}});
})();



